import { ReminderActionType } from './enums/reminder-action-type';

export class Reminder {
    public id: number = null;
    public name: string = null;
    public organizationId: string = null;
    public folderId: string = null;
    public creationDate: Date = null;
    public nextOccurenceDate: Date = null;
    public occurenceFrequency: number = null;
    public maxOccurence: number = null;
    public remainingOccurence: number = null;
    public actionType: ReminderActionType = null;
    public actionData: string = null;
    public viewId: number = null;
    public intervalRepeat: string = null;

    public static formatTime(time: number): string {
        if (!time || time === 0) {
            return '';
        }

        const minuts = time % 60;
        const totalHours = Math.floor(time / 60);
        const remainingHours = totalHours % 24;
        const totalDays = Math.floor(totalHours / 24);
        const remainingDays = totalDays % 7;
        const weeks = Math.floor(totalDays / 7);

        let format: string = '';

        if (weeks > 0) {
            format += `${weeks}s`;
        }

        if (remainingDays > 0) {
            if (format.length !== 0) {
                format += ' ';
            }
            format += `${remainingDays}j`;
        }

        if (remainingHours > 0) {
            if (format.length !== 0) {
                format += ' ';
            }
            format += `${remainingHours}h`;
        }

        if (minuts > 0) {
            if (format.length !== 0) {
                format += ' ';
            }
            format += `${minuts}m`;
        }

        console.log('format', format);
        return format;
    }
}
